export class AuditProgramAIRDTO {
  siteId: string;
  document_Type: any;
  documentId: any;
  auditProgramId: string;
  airTemplateId: string;
  airItemId: string;
  auditId: string;
  airDescription: string;
  orderId: string;
  checked: boolean = false;
  departmentId: string;
  sectionId: string;
  statusId: string;
  actionType: string;
  isAttachmentRequired: number;
  attachmentCount: string;
  auditorAttachmentCount: string;
  auditeeAttachmentCount: string;
  selectedAttachmentReq: boolean;

  auditorActionId: string;
  auditeeActionId: string;
  auditorRemarks: string;
  auditeeRemarks: string;
  auditorLastComment: string;
  auditeeLastComment: string;
  auditorLastCommentTime: string;
  auditeeLastCommentTime: string;
  isMcReleased: string;
  auditeeAction: string = '';
  auditorAction: string = '';
  pending: string = '0';
  partiallyCompleted: string = '0';
  accepted: string = '0';
  partiallyAccepted: string = '0';
  pendingAtAuditee: string = '0';
  notAccepted: string = '0';

  completed: string = '0';
  createdBy: string;
  createdOn: string;
  modifiedBy: string;
  modifiedOn: string;

  createdEmail: string;
  modifiedEmail: string;

  filePath: string;
}
